<template lang="html">
  <transition v-if="modalOpen" name="modal">
    <div
      v-tracking-context="{ page_type: webtrekkPageType }"
      class="registration-fence"
    >
      <div :class="contentClasses">
        <component :is="modalComponent" v-bind="modalProps" @close="modalClose">
          <template #default="slotProps">
            <a
              v-click-track="
                slotProps.clickTrack || {
                  event_element: 'button',
                  action_type: 'close'
                }
              "
              class="registration-fence__close"
              @click="modalClose"
            >
              <svg-icon icon-name="close-light" />
            </a>
          </template>
        </component>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import Session from '@/components/session.vue'

export default {
  name: 'Modal',
  props: {
    webtrekkPageType: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState(['modalOpen', 'modalComponent', 'modalProps']),
    ...mapGetters(['isUserKnown']),
    contentClasses() {
      return {
        'registration-fence__content': true,
        'registration-fence__content--no-padding':
          this.modalProps && !!this.modalProps.modalNoPadding,
        'registration-fence__content--narrow':
          this.modalProps && !!this.modalProps.modalNarrow,
        'registration-fence__content--wide':
          this.modalProps && !!this.modalProps.modalWide
      }
    }
  },
  mounted() {
    EventBus.on('sessionModal:open', (_event, { intent, intentData }) => {
      this.$store.commit('modalOpen', {
        component: Session,
        props: {
          intent,
          intentData,
          modalWide: true,
          initialTab: this.isUserKnown ? 'login' : 'registration',
          searchProfile: {}
        }
      })
    })
  },
  methods: {
    ...mapMutations(['modalClose'])
  }
}
</script>

<style lang="scss" scoped>
.registration-fence,
.registration-fence__content {
  transition-duration: 0.3s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .registration-fence__content {
    transform: scale(1.1);
  }
}
</style>
